import { Link, useLocation } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-[70vh] w-full flex-col items-center justify-center px-4 py-20 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-100 text-foreground-400">
        <i className="ri-compass-discover-line text-3xl"></i>
      </span>
      <h1 className="mt-5 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">404 页面未找到</h1>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
        抱歉，你访问的页面不存在或已被移动。
      </p>
      <p className="mt-1 break-all font-mono text-xs text-foreground-400">{location.pathname}</p>
      <div className="mt-7 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/category/all"
          className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          浏览全部网站
        </Link>
      </div>
    </div>
  );
}